export interface LocationCoordinates {
  lat: number;
  lng: number;
}

export interface ReverseGeocodeResult {
  zipCode: string | null;
  city?: string;
  state?: string;
}

export const getBrowserLocation = (): Promise<LocationCoordinates> => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by this browser'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      },
      (error) => {
        let errorMessage = 'Failed to get location';
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = 'Location permission denied';
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = 'Location information unavailable';
            break;
          case error.TIMEOUT:
            errorMessage = 'Location request timed out';
            break;
        }
        reject(new Error(errorMessage));
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  });
};

export const reverseGeocodeToZip = (
  lat: number,
  lng: number
): Promise<ReverseGeocodeResult> => {
  return new Promise((resolve) => {
    if (!window.google || !window.google.maps) {
      resolve({ zipCode: null });
      return;
    }

    const geocoder = new google.maps.Geocoder();
    const latlng = { lat, lng };

    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status === 'OK' && results && results[0]) {
        const addressComponents = results[0].address_components || [];

        const zipComponent = addressComponents.find((component) =>
          component.types.includes('postal_code')
        );

        const cityComponent = addressComponents.find((component) =>
          component.types.includes('locality')
        );

        const stateComponent = addressComponents.find((component) =>
          component.types.includes('administrative_area_level_1')
        );

        resolve({
          zipCode: zipComponent?.long_name || null,
          city: cityComponent?.long_name,
          state: stateComponent?.short_name,
        });
      } else {
        console.error('Geocoder failed:', status);
        resolve({ zipCode: null });
      }
    });
  });
};